export default () => ({
  activePanel: null,
  get menuOpen() {
    return this.activePanel === 'menu';
  },
  get searchOpen() {
    return this.activePanel === 'search';
  },
  get accountOpen() {
    return this.activePanel === 'account';
  },
  toggleMenu() {
    this.activePanel = this.menuOpen ? null : 'menu';
  },
  toggleSearch() {
    this.activePanel = this.searchOpen ? null : 'search';
  },
  toggleAccount() {
    this.activePanel = this.accountOpen ? null : 'account';
  },
  closePanels() {
    this.activePanel = null;
  },
});
